
import { mapGetters,mapActions } from 'vuex'
export default {
 props: {
    question: {
      default: '',
      type: String,
    },
    active: {
      default: '',
      type: String,
    },
    answer: {
      default: '',
      type: String,
    },
 },
 data() {
    return {
      // isActive: this.active !== ''
    }
  },
  computed: {
    ...mapGetters({
      activeFaq : 'pages/getActiveFaq',
    }),
  },
  mounted(){
    if(this.active !== ''){
      this.updateFaq(this.$props.question)
    }
  },
  methods: {
    ...mapActions({
      updateActiveFaq: 'pages/updateActiveFaq',
    }),
    updateFaq(faq){
      this.updateActiveFaq(faq)
    }
  }
}
